import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import {
  validateDateRange,
  validateDate,
} from '@department-of-veterans-affairs/platform-forms-system/validation';
import VaMemorableDateField from 'platform/forms-system/src/js/web-component-fields/VaMemorableDateField';
import fullSchema from 'vets-json-schema/dist/21-526EZ-ALLCLAIMS-V2-schema.json';
import { getPageTitle } from '../../utils/conditionalLogic';
import { reviewDateField } from '../../components/ReviewDateField';

const { serviceInformation } = fullSchema.properties;

// rewrite validation of date range as default validation uses `to` and `from`
// instead of beginDate and endDate
const validateObligationDateRange = (
  errors,
  dateRange,
  formData,
  schema,
  errorMessages,
) =>
  validateDateRange(
    { to: errors.endDate },
    { from: dateRange.beginDate, to: dateRange.endDate },
    formData,
    schema,
    errorMessages,
  );

export default {
  uiSchema: {
    ...titleUI(props =>
      getPageTitle({
        ...props,
        text: 'Obligation term of service dates for the',
      }),
    ),
    serviceInformation: {
      reservesNationalGuardService: {
        obligationTermsOfService: {
          'ui:validations': [validateObligationDateRange],
          'ui:errorMessages': {
            pattern: 'End date must be after start date',
            required: 'Please enter a date',
          },
          beginDate: {
            'ui:title': 'Enter your start date',
            'ui:webComponentField': VaMemorableDateField,
            'ui:reviewField': reviewDateField,
            'ui:required': () => true,
            'ui:validations': [validateDate], // TODO: maybe add additional validates for V2
            'ui:errorMessages': {
              required: 'Enter a valid date',
              pattern: 'Provide a valid date',
            },
            'ui:options': {
              monthSelect: false,
            },
          },
          endDate: {
            'ui:title': 'Enter your end date',
            'ui:webComponentField': VaMemorableDateField,
            'ui:reviewField': reviewDateField,
            'ui:required': () => true,
            'ui:validations': [validateDate], // TODO: maybe add additional validates for V2
            'ui:errorMessages': {
              required: 'Enter a valid date',
            },
            'ui:options': {
              monthSelect: false,
            },
          },
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['serviceInformation'],
    properties: {
      serviceInformation: {
        type: 'object',
        required: ['reservesNationalGuardService'],
        properties: {
          reservesNationalGuardService: {
            type: 'object',
            required: ['obligationTermsOfService'],
            properties: {
              obligationTermsOfService: {
                type: 'object',
                required: ['beginDate', 'endDate'],
                properties:
                  serviceInformation.properties.reservesNationalGuardService
                    .properties.obligationTermsOfService.properties,
              },
            },
          },
        },
      },
    },
  },
};
